import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  COPY_LABEL: `${cleanedFilename(__filename)}-copy-label`,
  COPIED_LABEL: `${cleanedFilename(__filename)}-copied-label`,
};
